import React from 'react';
import axios from 'axios';
import { Tab, Header, Segment, Responsive } from 'semantic-ui-react';
import ActiveSPImpl from './ActiveSPImpl';
import ArchivedSPImpl from './ArchivedSPImpl';
import { fetchSPStatuses } from '../../Lookups/util';
import { ToastContainer, toast } from 'react-toastify';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;

export default class Implementations extends React.Component {
    constructor(props) {
        super(props);
        let storedId = '';
        let storedBasicName = '';

        if (localStorage.getItem('id')) {
            storedId = parseInt(localStorage.getItem('id'), 10);
        }
        if (localStorage.getItem('basicName')) {
            storedBasicName = parseInt(localStorage.getItem('basicName'), 10);
        }
        this.state = {
            data: [],
            SPStatuses: []
        };
        this.getImplemenations = this.getImplemenations.bind(this);
    }

    UNSAFE_componentWillMount() {
        axios.all([fetchSPStatuses()])
            .then(axios.spread((res) => {
                const SPStatuses = res.data.map(el => ({
                    ...el, key: el.id, value: el.id, text: el.name
                }));

                this.setState({
                    SPStatuses
                });
            }))
            .catch(err => {
                console.log('Failed to fetch study program statuses.');
            });
    }


    componentDidMount() {
        if (this.props.location.state) {
            if (this.props.location.state.id) {
                localStorage.setItem('id', this.props.location.state.id);
            }

            if (this.props.location.state.name) {
                localStorage.setItem('basicName', this.props.location.state.name);
            }

            localStorage.removeItem('studyProgramDescription');

            if (this.props.location.state.copiedCourses) {
                toast('Predmeti i informacije o semestrima su uspješno kopirani.');
            }

            if (this.props.location.state.copiedImplementation || this.props.location.state.copiedCourses) {
                this.props.history.replace({
                    ...this.props.location,
                    state: undefined
                });
            }
        }

        this.getImplemenations();
    }
    getImplemenations() {
        let id = '';
        if (localStorage.getItem('id')) id = parseInt(localStorage.getItem('id'), 10); else id = this.props.location.state.id;
        axios.get(`study-programs/implementations-for-basic/${id}`)
            .then(res => {
                this.setState({ data: res.data, loaded: true });
            })
            .catch(err => {
                console.log('Failed to fetch study program implementations');
            });
    }

    render() {
        const { SPStatuses } = this.state;
        const panes = localStorage.getItem('archived') === 'true' ?
            [{
                menuItem: 'Arhivirane implementacije',
                render: () => (<Tab.Pane attached={false} as={Responsive}>
                    <ActiveSPImpl
                        data={this.state.data.filter(el => SPStatuses.find(status => el.studyProgram.studyProgramStatus.id === status.id)._key === 'archived')}
                        loaded={this.state.loaded}
                        getImplemenations={this.getImplemenations}
                        SPStatuses={SPStatuses}
                    /></Tab.Pane>)
            }] :
            [
                {
                    menuItem: 'Aktivne implementacije',
                    render: () => (<Tab.Pane attached={false} as={Responsive}>
                        <ActiveSPImpl
                            data={this.state.data.filter(el => el.studyProgram.studyProgramStatus._key === 'active')}
                            loaded={this.state.loaded}
                            getImplemenations={this.getImplemenations}
                            SPStatuses={SPStatuses}
                        /></Tab.Pane>)
                },
                {
                    menuItem: 'Pasivne implementacije',
                    render: () => (<Tab.Pane attached={false} as={Responsive}>
                        <ActiveSPImpl
                            data={this.state.data.filter(el => el.studyProgram.studyProgramStatus._key === 'pasive')}
                            loaded={this.state.loaded}
                            getImplemenations={this.getImplemenations}
                            SPStatuses={SPStatuses}
                        /></Tab.Pane>)
                },
                {
                    menuItem: 'Arhivirane implementacije',
                    render: () => (<Tab.Pane attached={false} as={Responsive}>
                        <ActiveSPImpl
                            data={this.state.data.filter(el => el.studyProgram.studyProgramStatus._key === 'archived')}
                            loaded={this.state.loaded}
                            getImplemenations={this.getImplemenations}
                            SPStatuses={SPStatuses}
                        /></Tab.Pane>)
                },
            ];

        return (
            <div>
                <Header as="h1">Implementacije smjera (studijskog programa)</Header>
                <Segment.Group raised>
                    <Segment>
                        <Header
                            as="h3"
                            content={localStorage.getItem('basicName') ? localStorage.getItem('basicName') : this.props.location.state.name}
                            subheader="Osnovni studijski program"
                        >

                        </Header>
                    </Segment>
                    {/*<Segment><Header as="h3">Osnovni smjer: {localStorage.getItem('basicName') ? localStorage.getItem('basicName') : this.props.location.state.name}*/}
                    {/*</Header>*/}
                    {/*</Segment>*/}
                    <Segment><Tab menu={{ secondary: true, pointing: true, color: 'blue' }} panes={panes} /></Segment>

                    <ToastContainer hideProgressBar />
                </Segment.Group>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/Admin/CreateStudyProgram/Implementations.js